export default {
    methods: {
        getDossier (dossierNr) {
            return this.dossiers.find(dossier => parseInt(dossier.nr) === dossierNr)
        },

        getProfile (dossier, profileNr) {
            return dossier?.profielen.find(profiel => parseInt(profiel.nr) === profileNr)
        },

        getCrebo (crebos) {
            return crebos.map(crebo => crebo.nr).join(', ')
        },

        getDate (crebos) {
            return crebos.map(crebo => crebo.valid_from).join(', ')
        },

        getDossierName (dossierNr, profileNr) {
            if (this.dossiers.length > 0) {
                const dossier = this.getDossier(dossierNr)

                if (dossier) {
                    if (dossier.titel === '-') return '-/-'

                    const profile = this.getProfile(this.getDossier(dossierNr), profileNr)

                    return `${dossier.titel} (${this.getCrebo(dossier.crebos)})/${profile.titel} (${this.getCrebo(profile.crebos)}) vanaf ${this.getDate(profile.crebos)}`
                }

                return null
            }
        }
    }
}
